import { NOTIFICATION_API, UPDATE_NOTIFICATION_API } from "@constants/auth/Api";
import { API_KEY } from "@constants/AppConfig";
import { fetchAuthSession } from 'aws-amplify/auth';
import { fallbackUpdateNotification } from "./sharedUtils";

export async function sendPushNotification<T extends Record<string, any>>(body: T): Promise<any> {
  try {
    const response = await fetch(NOTIFICATION_API, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': API_KEY,
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      console.error(`API Error: ${response.status} ${response.statusText} - ${JSON.stringify(errorData)}`);
    }

    return response.json();
  } catch (error: any) {
    console.error('Push notification failed:', error);
    throw error;
  }
}

export interface UpdateNotificationPayload {
  uuid?: string;
  device_id?: string;
  nurse_summary?: string;
  nurse_name?: string;
  command?: string;
}

export async function updateNotificationApi(payload: UpdateNotificationPayload, accessToken?: string): Promise<any> {
  let token = accessToken;
  if (!token) {
    try {
      const session = await fetchAuthSession();
      token = session.tokens?.accessToken?.toString();
    } catch (e) {
      console.warn('Could not fetch auth session token:', e);
    }
  }

  try {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      'x-api-key': API_KEY,
    };
    if (token) {
      headers['access-token'] = token;
      headers['Authorization'] = `Bearer ${token}`;
    }
    const response = await fetch(UPDATE_NOTIFICATION_API, {
      method: 'POST',
      headers,
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      console.error(`API Error: ${response.status} ${response.statusText} - ${JSON.stringify(errorData)}`);
      throw new Error(errorData.message || 'Failed to update notification via API');
    }

    return await response.json();
  } catch (error: any) {
    console.warn('API updateNotificationApi fetch failed, executing fallback update:', error);
    try {
      return await fallbackUpdateNotification(payload);
    } catch (fallbackErr) {
      console.error('Fallback notification update failed:', fallbackErr);
      throw error;
    }
  }
}


